import Vue from 'vue'

const START_TIME = "9:00";
const END_TIME = "21:30";
const DAY = {
  0: '日',
  1: '月',
  2: '火',
  3: '水',
  4: '木',
  5: '金',
  6: '土'
};

var datetimeUtil = {
  
  getSelectedTime(arrays, listDate, startTime) {
    let listSelectedDate = [];
    for (var i = 0; i < arrays.length; i++) {
      for (var j = 0; j < arrays[i].length; j++) {
        if (arrays[i][j]) {
          var time = {
            date: new Date(
              listDate[i].getFullYear(), 
              listDate[i].getMonth(), 
              listDate[i].getDate(), 
              parseInt(startTime[j].split(":")[0], 10), 
              parseInt(startTime[j].split(":")[1], 10), 
              0) 
          };
          listSelectedDate.push(time);
        }
      }
    }

    if(listSelectedDate.length === 0) {
      return listSelectedDate;
    }

    var loop = listSelectedDate[0].loop = 1
    for (var i = 1; i < listSelectedDate.length; i++) {
      var selectedDate = listSelectedDate[i];
      var before30minutes = new Date(selectedDate.date.getFullYear(), selectedDate.date.getMonth(), selectedDate.date.getDate(), selectedDate.date.getHours(), selectedDate.date.getMinutes(), 0);
      before30minutes.setMinutes(selectedDate.date.getMinutes() -30);
      if (before30minutes.getTime() === listSelectedDate[i - 1].date.getTime()) {
        selectedDate.loop = ++loop;
      } else {
        selectedDate.loop = loop = 1;
      }
    }
    return listSelectedDate;
  },

  getJSONDateTime(list) {
    let jsonDates = [];
    list.forEach((item) => {
      let dateKey = `${item.date.getFullYear()}-${(item.date.getMonth() + 1).toString().padStart(2, '0')}-${item.date.getDate().toString().padStart(2, '0')}`;
      let dateEntry = jsonDates.find(entry => entry.date === dateKey);
      if (!dateEntry) {
        dateEntry = { date: dateKey, times: [] };
        jsonDates.push(dateEntry);
      }
      let time = `${item.date.getHours().toString().padStart(2, '0')}:${item.date.getMinutes().toString().padStart(2, '0')}`;
      dateEntry.times.push(time);
    });
    return jsonDates;
  },

  formatTime(time) {
    const [h, m] = time.split(":");
    return `${parseInt(h, 10)}:${m}`;
  },

  getDisplayDateTime(dateTimeJSON) {
    let dateList = dateTimeJSON;

    dateList.sort((a, b) => {
      let dateA = new Date(a.date);
      let dateB = new Date(b.date);

      if(dateA.getTime() !== dateB.getTime()) {
        return dateA - dateB;
      }

      let [hourA, minitueA] = a.times[0].split(":").map(Number);
      let [hourB, minitueB] = b.times[0].split(":").map(Number);
      let timeA = hourA * 60 + minitueA;
      let timeB = hourB * 60 + minitueB;
      return timeA - timeB;
    })

    const formattedSchedule = dateList.map(entry => {
      let [year, month, day] = entry.date.split("-");
      let formattedDate = `${parseInt(month, 10)}/${parseInt(day, 10)}(${DAY[new Date(entry.date).getDay()]}) `;
      let times = entry.times;
      let timeRanges = [];
      let startTime = times[0];

      let timediff = 0;
      for (let i = 1; i <= times.length; i++) {
        if(i < times.length) {
          let [prevHour, prevMinute] = times[i - 1].split(":").map(Number);
          let [currHour, currMinute] = times[i].split(":").map(Number);
          timediff = (currHour * 60 + currMinute) - (prevHour * 60 + prevMinute)
        }
        if (i === times.length || timediff > 30) {
          if (this.formatTime(startTime) == START_TIME && times[i - 1] == END_TIME) {
            timeRanges.push("終日");
          } else if (startTime === times[i - 1]) {
            timeRanges.push(`${this.formatTime(startTime)}`);
          } else {
            timeRanges.push(`${this.formatTime(startTime)}～${this.formatTime(times[i - 1])}`);
          }
          startTime = times[i];
        }
      }
      return `${formattedDate} ${timeRanges.map(range => range === "終日" ? range : `${range}開始`).join("、")}`;
    }).join("\n");
    return formattedSchedule;
  }
}

Vue.use({
  install(Vue, options) {
    Vue.prototype['$datetimeUtil'] = datetimeUtil
  }
})

export default datetimeUtil


// WEBPACK FOOTER //
// ./src/services/datetime-utility.js